export default {
  breadcrumbCatalog: 'Catalog',
  breadcrumbFavorites: 'Favorites',
  title: 'Your favorites',
  count: 'no games saved | one game saved | {count} games saved',
  sortLabel: 'Sort favorites',
  sort: {
    recent: 'Recently added',
    oldest: 'Oldest first',
    name: 'Name A–Z',
    price_asc: 'Price ↑',
    price_desc: 'Price ↓',
  },
  gridView: 'Grid view',
  listView: 'List view',
  empty: {
    heading: 'No favorites yet',
    body: 'Tap the heart on any game to save it for later and track price drops.',
    cta: 'Browse catalog',
  },
};
